<template>
  <div>
      <video autoplay muted loop class="hover_video" src="@/assets/video/contentcreator.mp4"></video>
      <p class="description pd-top-40">
        SMN & StarHits berkolaborasi membuat konten digital yang menarik dengan para content creator tanah air. Saksikan konten-konten menarik dan unik yang dipersembahkan spesial untuk HUT 32 MNC Group.
      </p>
      <!-- <p class="link description mg-top-20" @click="movePage()">Selengkapnya</p> -->
  </div>
</template>

<script>
export default {
  name: 'Content',
  data () {
    return {

    }
  },
  methods: {
    movePage() {
      this.$router.push('/content-creator')
    }
  }
}
</script>
